import NotificationStore from './NotificationStore';
import { persistance } from './NotificationStore';

export { persistance };
export default NotificationStore;
